import { useTranslate } from '@tolgee/react';
import { useCallback } from 'react';

export const langRegionMap: Record<Aide.WhatsAppLanguage, Aide.WhatsAppRegion> = {
  zh_CN: 'CN',
  fil: 'PH',
  th: 'TH',
  ms: 'MY',
  pt_BR: 'BR',
  id: 'ID',
  vi: 'VN',
  en: 'SG',
  es_MX: 'MX',
};

export const regionLangMap: Record<Aide.WhatsAppRegion, Aide.WhatsAppLanguage> = {
  CN: 'zh_CN',
  PH: 'fil',
  TH: 'th',
  MY: 'ms',
  BR: 'pt_BR',
  ID: 'id',
  VN: 'vi',
  SG: 'en',
  MX: 'es_MX',
};

export const langMap: Record<Aide.WhatsAppLanguage, General.Language> = {
  zh_CN: 'zh-CN',
  fil: 'tl',
  th: 'th',
  ms: 'my',
  pt_BR: 'pt',
  id: 'id',
  vi: 'vi',
  en: 'en-US',
  es_MX: 'es',
};

export const regionPhoneMap: Record<Aide.WhatsAppRegion, number> = {
  CN: 86,
  PH: 63,
  TH: 66,
  MY: 60,
  BR: 55,
  ID: 62,
  VN: 84,
  SG: 65,
  MX: 52,
};

export function useGetRegionLabel() {
  const { t } = useTranslate();

  const getRegionLabel = useCallback(
    (region: Aide.WhatsAppRegion) => {
      if (region === 'CN') {
        return t('phoneCountry.cn');
      }
      return t(`region.${region.toLowerCase()}`);
    },
    [t],
  );

  return {
    getRegionLabel,
    t,
  };
}
